import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import MerchandiseDetailPage from '../MerchandiserDetailPage/MerchandiserDetailPage';
import MerchandiserLayout from './MerchandiserLayout';
import MerchandiserIncidentListPage from './MerchandiserDetail/MerchandiserIncidentListPage';
import MerchandiserMonitoring from './MerchandiserDetail/MerchandiserMonitoring';
import MerchandiserSettings from './MerchandiserDetail/MerchandiserSettings';
import { MerchandiserExpertView } from './MerchandiserDetail/MerchandiserExpertView';
import { MerchandiserStandardView } from './MerchandiserDetail/MerchandiserStandardView';

export function MerchandiserRoutes() {
  return (
    <React.Fragment>
      <Routes>
        <Route element={<MerchandiserLayout />}>
          <Route path="history" element={<MerchandiserMonitoring />} />
          <Route path="settings" element={<MerchandiserSettings />} />
          <Route path="alarms" element={<MerchandiserIncidentListPage />} />
          <Route path="detail" element={<MerchandiseDetailPage />} />
          <Route path="expert-view" element={<MerchandiserExpertView />} />
          <Route path="standard-view" element={<MerchandiserStandardView />} />
        </Route>
        {/* redirect to detail */}
        <Route path="" element={<Navigate to="detail" replace={true} />} />
      </Routes>
    </React.Fragment>
  );
}

export default MerchandiserRoutes;
